import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Paper from "@material-ui/core/Paper";
import Grow from "@material-ui/core/Grow";
import Popper from "@material-ui/core/Popper";
import headerLinksStyle from "../../assets/jss/material-dashboard-pro-react/components/headerLinksStyle";
import UserMenu from "../Header/UserMenu";
import Collapse from '@material-ui/core/Collapse';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

class HeaderLinks extends React.Component {
  state = {
    open: false,
    tenantsListOpen: false,
    anchorEl: null,
  };
  handleClick = (event) => {
    this.setState({ open: !this.state.open, anchorEl: event.currentTarget });
  };
  handleClose = () => {
    this.setState({ open: false, tenantsListOpen: false });
  };
  handleTenantsListClick = () => {
    this.setState({ tenantsListOpen: !this.state.tenantsListOpen });
  };
  handleTenantsListClose = () => {
    this.setState({ tenantsListOpen: false });
  };
  handleLogoutClick = () => {
    this.handleClose();
    this.props.authStore.logout();
  }

  render() {
    const { classes, rtlActive } = this.props;
    const { open } = this.state;

    const dropdownItem = classNames(
      classes.dropdownItem,
      classes.primaryHover,
      { [classes.dropdownItemRTL]: rtlActive }
    );

    const dropdownItemWithIcon = classNames(
      classes.dropdownItem,
      classes.primaryHover,
      'dropdownItemWithIcon'
    );

    return (
      <div className='class-manager-container'>
        <div>
          <UserMenu
            userAvatarUrl={this.props.userAvatarUrl}
            headerMainText={this.props.headerMainText}
            headerSubText={this.props.headerSubText}
            handleClick={this.handleClick}
          />

          {/* Dropdown to show when the user icon is clicked */}
          <Popper
            open={open}
            anchorEl={this.state.anchorEl}
            transition
            disablePortal
            placement="bottom"
            className={classNames({
              [classes.popperClose]: !open,
              [classes.pooperResponsive]: true,
              [classes.pooperNav]: false
            })}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                id="menu-list"
                style={{ transformOrigin: "0 0 0" }}
              >
                <Paper className={classes.dropdown}>
                  <ClickAwayListener onClickAway={this.handleClose}>
                    <MenuList role="menu">
                      {
                        this.props.showTenants &&
                        <MenuItem className={dropdownItemWithIcon} onClick={this.handleTenantsListClick}>
                          {'Tenants'}
                          <ListItemIcon>
                            {this.state.tenantsListOpen ? <ExpandLess /> : <ExpandMore />}
                          </ListItemIcon>
                        </MenuItem>
                      }

                      {
                        this.props.showTenants &&
                        <Collapse in={this.state.tenantsListOpen} timeout="auto" unmountOnExit={true}>
                          {this.props.children}
                        </Collapse>
                      }

                      <MenuItem
                        onClick={this.handleLogoutClick}
                        className={dropdownItem}
                      >
                        {'Logout'}
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </div>
    );
  }
}

HeaderLinks.propTypes = {
  classes: PropTypes.object.isRequired,
  rtlActive: PropTypes.bool,
  showTenants: PropTypes.bool,
};

export default withStyles(headerLinksStyle)(HeaderLinks);
